import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { getErpErrorMessage } from "@modules/erpIntegrations/utils";

import { deleteEndpointService } from "./service";
import { UseDeleteEndpointMutationOptions } from "./types";

export function useDeleteEndpointMutation(options?: UseDeleteEndpointMutationOptions) {
  const { open } = useNotification();

  return useMutation<void, ApiError, number>({
    mutationFn: deleteEndpointService,
    onError: (error) => {
      open?.({
        type: "error",
        message: getErpErrorMessage(error),
      });
    },
    ...options,
  });
}
